export default {
  selectPreset: 'Wybierz ustawienie wstępne',
  resetPreset: 'Resetuj zmiany ustawień wstępnych',
};
